import type { AdminVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveAdmins = createApiThunk<AdminVM[], void>(
  "admins/adminRetrieveAdmins",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.adminList();
  },
);
